import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Highlight from '@tiptap/extension-highlight';
const MenuBar = ({ editor }) => {
    if (!editor) {
        return null;
    }
    return (_jsxs("div", { className: "flex flex-wrap gap-1 p-2 border-b border-secondary-200 bg-secondary-50 rounded-t-lg", children: [_jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleBold().run(), className: `px-2 py-1 rounded text-sm font-medium transition-colors ${editor.isActive('bold')
                    ? 'bg-primary-600 text-white'
                    : 'bg-white text-secondary-700 hover:bg-secondary-100 border border-secondary-200'}`, title: "Bold", children: _jsx("strong", { children: "B" }) }), _jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleItalic().run(), className: `px-2 py-1 rounded text-sm font-medium transition-colors ${editor.isActive('italic')
                    ? 'bg-primary-600 text-white'
                    : 'bg-white text-secondary-700 hover:bg-secondary-100 border border-secondary-200'}`, title: "Italic", children: _jsx("em", { children: "I" }) }), _jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleUnderline().run(), className: `px-2 py-1 rounded text-sm font-medium transition-colors ${editor.isActive('underline')
                    ? 'bg-primary-600 text-white'
                    : 'bg-white text-secondary-700 hover:bg-secondary-100 border border-secondary-200'}`, title: "Underline", children: _jsx("span", { className: "underline", children: "U" }) }), _jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleHighlight().run(), className: `px-2 py-1 rounded text-sm font-medium transition-colors ${editor.isActive('highlight')
                    ? 'bg-yellow-400 text-secondary-900'
                    : 'bg-white text-secondary-700 hover:bg-secondary-100 border border-secondary-200'}`, title: "Highlight", children: _jsx("span", { className: "bg-yellow-200 px-1", children: "H" }) }), _jsx("div", { className: "w-px bg-secondary-300 mx-1" }), _jsx("button", { type: "button", onClick: () => editor.chain().focus().toggleBulletList().run(), className: `px-2 py-1 rounded text-sm font-medium transition-colors ${editor.isActive('bulletList')
                    ? 'bg-primary-600 text-white'
                    : 'bg-white text-secondary-700 hover:bg-secondary-100 border border-secondary-200'}`, title: "Bullet List", children: _jsx("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M4 6h16M4 12h16M4 18h16" }) }) })] }));
};
const RichTextEditor = ({ content, onChange, placeholder }) => {
    // Note: The "Duplicate extension names" warning in console is expected when multiple
    // RichTextEditor instances are on the same page. This is a known Tiptap behavior
    // and doesn't affect functionality - each editor instance works independently.
    const editor = useEditor({
        extensions: [
            StarterKit.configure({
                bulletList: {
                    keepMarks: true,
                    keepAttributes: false,
                },
            }),
            Underline,
            Highlight.configure({ multicolor: false }),
        ],
        content: content,
        onUpdate: ({ editor }) => {
            onChange(editor.getHTML());
        },
        editorProps: {
            attributes: {
                class: 'prose prose-sm max-w-none focus:outline-none min-h-[150px] p-3',
            },
        },
    });
    // Update editor content when prop changes
    React.useEffect(() => {
        if (editor && content !== editor.getHTML()) {
            editor.commands.setContent(content || '');
        }
    }, [content, editor]);
    return (_jsxs("div", { className: "border border-secondary-300 rounded-lg overflow-hidden bg-white", children: [_jsx(MenuBar, { editor: editor }), _jsx(EditorContent, { editor: editor }), !content && placeholder && (_jsx("div", { className: "absolute top-12 left-3 text-secondary-400 pointer-events-none", children: placeholder }))] }));
};
export default RichTextEditor;
